import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import dayjs from 'dayjs';

import 'dayjs/locale/zh-cn';

import zhCN from 'antd/locale/zh_CN';

import {ConfigProvider, Spin} from "antd";
import {DevSupport} from "@react-buddy/ide-toolbox";
import {BasicRoute} from "./router/Router";

dayjs.locale('zh-cn');

import store from '@/store'
import {Provider, useSelector} from 'react-redux'


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ConfigProvider locale={zhCN} theme={{cssVar: true}}>
    <Provider store={store}>
      <BasicRoute/>
    </Provider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
